module.exports = __webpack_public_path__ + "assets/img/Australian-Seniors-Content-Marketing-w720.eaeee411.jpg";